module.exports = __webpack_public_path__ + "img/건강노화힐링.958a17b8.png";